<template>
    <div>
        <div class="leaves_top"></div>
        
        <HeaderMenu_Site />
        <LateralMenu_Site />

        <div class="page-content" id="homepage">
            <img class="logo" src="/public/assets/images/Lock%20Quest-Escape%20Game-Logo.png" 
                alt="Escape Game Caen (Bretteville-sur-Odon), jeu d’évasion grandeur nature et de loisirs à Caen. Un parfum d'aventure et de légende : chacun de nos scénarios vous fera voyager dans un pays du monde différent. Quelle sera votre destination ?" />

            <div id="accueil" class="content">
                <div>
                    <div class="bandeau">
                        <span>- ESCAPE GAME -</span>
                        <span>Evadez-vous à <a href="/#infos-pratiques">Bretteville-sur-Odon !</a></span>
                        
                        <div>
                            <div class="bandeau-links">
                                <ul>
                                    <router-link to="/#concept" v-slot="{ href, route, navigate, isActive, isExactActive }">
                                        <li><a v-bind:href="href">Escape Game</a> - </li>
                                    </router-link>
                                    <li><a href="https://www.padquest.fr" target="_blank">Escape Game Mobiles</a> - </li>
                                    <router-link to="/#nestor-bomb-simulator" v-slot="{ href, route, navigate, isActive, isExactActive }">
                                        <li v-bind:class="[ isExactActive && 'active' ]"><a v-bind:href="href">NESTOR</a></li>
                                    </router-link>
                                </ul>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <div id="google-reviews" class="content">
                <div>
                    <div class="wordings left">
                        <span>5 mondes</span>
                        <span>à explorer</span>
                        <span>en 60 mn</span>
                        <span class="icon"></span>
                        <span>
                            <a href="/nos-scenarios-escape-caen#tombeau-siptah">Égypte</a> - 
                            <a href="/nos-scenarios-escape-caen#secret-mayoko">Japon</a> - 
                            <a href="/nos-scenarios-escape-caen#gardiens-vichama">Pérou</a> - 
                            <br /><a href="/nos-scenarios-escape-caen#talisman-titans">Cambridge</a> - 
                            <a href="/nos-scenarios-escape-caen#legende-ishtar">Nimrod</a></span>
                    </div><!--
                    --><div class="wordings right">
                        <span>On s'adapte à vous</span>
                        <span>3 niveaux de difficulté</span>
                        <span class="button">Classique</span>
                        <br />
                        <span class="button">Challenge</span>
                        <br />
                        <span class="button">Expert</span>
                    </div>
                </div>
                
                <div>
                    <div class="logo" v-on:click="redirect('https://www.google.fr/maps/place/Lock+Quest+-+Escape+game+Caen/@49.168228,-0.4072572,17z/data=!3m1!4b1!4m7!3m6!1s0x480a43e5c60dc75b:0x7229b120e1ec30af!8m2!3d49.168228!4d-0.4050685!9m1!1b1', 'renvoi_google_reviews')"></div>
                    <carousel v-bind:scrollPerPage="true" v-bind:perPage="1" v-bind:paginationEnabled="false"
                        v-bind:autoplay="true" v-bind:autoplayTimeout="7500" v-bind:autoplayHoverPause="true">
                        <slide>
                            <div>
                                “Deux salles avec deux univers bien différents mais toujours avec une immersion totale!! Pour tous ceux qui
                                <br />préfèrent les mécanismes cachés plutôt que l'ouverture de cadenas, il faut essayer Lock Quest!!” Jordan LAIR
                            </div>
                        </slide>
                        <slide>
                            <div>
                                “Excellent. La mise en scène est impressionnante et la résolution des
                                <br />énigmes est très gratifiante. A faire absolument !!” Maxime Lespagnol
                            </div>
                        </slide>
                        <slide>
                            <div>
                                “Véritablement l'un des escape game le plus beau de Caen. Les décors sont très travaillés et les
                                <br />énigmes vraiment poussées (et pas juste cadenas, sur cadenas...). Nous avons fait les 2 pièces est
                                <br />vraiment nous recommandons vivement !” Armelle Huard
                            </div>
                        </slide>
                        <slide>
                            <div>
                                “Franchement l'un des meilleurs escape game dans tous les sens des termes ! Le décor, les énigmes
                                <br />tout est fait pour nous mettre dans l'environnement. Pressée de voir l'autre salle !” Mzelle Shadow
                            </div>
                        </slide>
                        <slide>
                            <div>
                                “L'accueil est chaleureux, l'énigme est parfaite, la réalisation superbe, bref, n'hésitez pas une seule
                                <br />seconde ! Vivement la seconde salle que nous ferons sans aucun doute mais avant nous ferons une
                                <br />chasse au trésor.” Kinoo B.
                            </div>
                        </slide>
                        <slide>
                            <div>
                                “Excellent moment . Des énigmes et des défis au top dans un univers particulièrement soigné dans
                                <br />les détails. Je recommande vivement!” Mickael Sévère
                            </div>
                        </slide>
                        <slide>
                            <div>
                                “Super moment passé en famille (de 12 à 47 ans). On s'était réparti les missions et tout le monde a
                                <br />été bien occupé durant 1h ! Nous n'avons pas vu le temps passer [...] Les enfants ont adoré car on a
                                <br />vraiment eu l'impression d'être des aventuriers/archéologues. [...] Un super Escape Game !” ego trip
                            </div>
                        </slide>
                        <slide>
                            <div>
                                “Super expérience ! Fidèle des escape game, j'ai retrouvé tout ce qui me plaît dans ces jeux : un
                                <br />scénario intéressant, un super décor et un game master très accueillant ! Le top :) Vivement les
                                <br />prochaines salles !” Mélanie Ferey
                            </div>
                        </slide>
                        <slide>
                            <div>
                                “Un accueil au top. L'entrée met directement dans l'ambiance et appelle à l'aventure. Et croyez moi,
                                <br />on n'est pas déçu du voyage! Tout respire ici le travail bien fait, l'artisanat et la volonté de proposer
                                <br />le meilleur aux participants et une expérience unique.” Arnaud Gilles
                            </div>
                        </slide>
                        <slide>
                            <div>
                                “Un super décor, une bonne histoire, un game master bien sympathique. On a passé un super
                                <br />vraiment nous recommandons vivement !” Armelle Huard
                            </div>
                        </slide>
                        <slide>
                            <div>
                                “Un super décor, une bonne histoire, un game master bien
                                <br />sympathique. On a passé un super moment, on recommande !” Banh Bao
                            </div>
                        </slide>
                    </carousel>
                </div>
            </div>

            <div id="concept" class="content">
                <div class="column left">
                    <div>
                        <span v-observe-visibility="{ callback: ovCallbackConcept, intersection: ovOptions, once: true }">
                            C'est quoi un Escape Game ?
                        </span>
                        <span v-observe-visibility="{ callback: ovCallbackConcept, intersection: ovOptions, once: true }">
                            <span>1 équipe, 1 pièce, 1 heure pour s'en sortir...</span>
                            Un savant mélange d'objets à trouver, d'énigmes à résoudre, de mécanismes et cadenas à ouvrir 
                            et plein de surprises à découvrir dans des décors incroyables.
                        </span>
                        <span v-observe-visibility="{ callback: ovCallbackConcept, intersection: ovOptions, once: true }">Le Plus Lock Quest®</span>
                        <span v-observe-visibility="{ callback: ovCallbackConcept, intersection: ovOptions, once: true }">
                            Un parfum d'aventure et de légende !
                            <br />Chacun de nos scénarios vous fera voyager dans un pays du monde différent. 
                            Quelle sera votre destination ?
                        </span>
                        <div>
                            <a href="/nos-scenarios-escape-caen">Voir nos énigmes</a><!--
                            --><a class="icon video" v-on:click="voirTrailer_buttonClick('https://www.youtube.com/embed/JjavMTkdAHU')">&nbsp;</a>
                        </div>
                    </div>
                </div><!--

                --><div class="column right">
                    <div>
                        <div v-observe-visibility="{ callback: ovCallbackConcept, intersection: ovOptions, once: true }">
                            <div class="icon team"></div>
                            <span>Par équipe de 2 à 5 joueurs</span>
                        </div>
                        <div v-observe-visibility="{ callback: ovCallbackConcept, intersection: ovOptions, once: true }">
                            <div class="icon time"></div>
                            <span>60 minutes chrono</span>
                        </div>
                        <div v-observe-visibility="{ callback: ovCallbackConcept, intersection: ovOptions, once: true }">
                            <div class="icon puzzle"></div>
                            <span>Des tonnes d'énigmes !</span>
                        </div>
                    </div>
                </div>
            </div>

            <div id="entreprises" class="content">
                <h2>Privatisation, Team Building, Escape Game mobiles</h2>
                <h3>
                    Collectivités, entreprises, pour vos séminaires ou événementiels, nous installons un scénario
                    <br />mobile directement dans vos locaux ou sous barnum. Découvrez également nos offres de privatisation.
                </h3>
                <a href="/entreprises">Offres Entreprises</a>
                <div class="logo-camion" v-observe-visibility="{ callback: ovCallbackEntreprises, intersection: ovOptions, once: true }"></div>
            </div>

            <div id="nestor-bomb-simulator" class="content">
                <div class="separation-blocs"></div>
                <div class="column">
                    <div>
                        <div>
                            <div class="logo"></div>
                            <div class="wordings">
                                <span>Découvrez NESTOR, le "bomb simulator"</span>
                                <br/><br />
                                Tic-tac... Le compte à rebours a commencé ! Votre équipe a 15 minutes pour désamorcer la bombe. 
                                <br/><br />
                                Qui sera le <span>Démineur</span> ? Lui seul pourra manipuler la bombe... Ou serez-vous un <span>Ingénieur</span> en possession de toutes les instructions ?
                                <br /><br />
                                Communication, logique, sang-froid : la moindre seconde compte ! À chaque partie un défi différent !
                            </div>
                            <a v-on:click="reserver_buttonClick('nestor-bomb-simulator')">Réserver</a><!--
                            --><a class="icon video" v-on:click="voirTrailer_buttonClick('https://www.youtube.com/embed/XPAK_8QFLII')">&nbsp;</a><!--
                            --><a class="icon scores" v-on:click="listeScores_buttonClick()">&nbsp;</a>
                        </div>
                    </div>
                </div>
            </div>

            <div id="tarifs" class="content">
                <div>Tarifs</div>
                <div>
                    Tarifs TTC. Valables pour une session d'Escape Game de 60 min. pour 2 à 5 personnes.
                    <br />Pour les jeux de piste, voir les tarifs sur le <a href="https://www.padquest.fr" target="_blank">site dédié</a>.
                </div>
                <div>
                    <div v-observe-visibility="{ callback: ovCallbackTarifs, intersection: ovOptions, once: true }">
                        <span class="nb-joueurs">2 joueurs</span>
                        <span class="prix">76€</span>
                    </div>
                    <div v-observe-visibility="{ callback: ovCallbackTarifs, intersection: ovOptions, once: true }">
                        <span class="nb-joueurs">3 joueurs</span>
                        <span class="prix">87€</span>
                    </div>
                    <br />
                    <div v-observe-visibility="{ callback: ovCallbackTarifs, intersection: ovOptions, once: true }">
                        <span class="nb-joueurs">4 joueurs</span>
                        <span class="prix">104€</span>
                    </div>
                    <div v-observe-visibility="{ callback: ovCallbackTarifs, intersection: ovOptions, once: true }">
                        <span class="nb-joueurs">5 joueurs</span>
                        <span class="prix">115€</span>
                    </div>
                </div>
            </div>

            <div id="infos-pratiques" class="content">
                <div>Infos pratiques</div>
                <div>
                    Nous sommes situés
                    <br /><span>6, chemin de Lamballard 14760 Bretteville-sur-Odon</span>
                </div>
                <div>
                    <div class="column left">
                        <div class="lockquest-map">
                            <iframe src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d2608.703916655879!2d-0.4072571839093153!3d49.16822797931912!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x480a43e5c60dc75b%3A0x7229b120e1ec30af!2sLock%20Quest%20-%20Escape%20game%20Caen!5e0!3m2!1sfr!2sfr!4v1596312468749!5m2!1sfr!2sfr" width="100%" height="304" frameborder="0" style="border:0;" allowfullscreen=""></iframe>
                        </div>
                    </div>
                    <div class="column right">
                        <div>
                            <span>Horaires :</span>
                            Du mardi au dimanche
                            <br />Sessions toutes les 1h45
                            <br />de 10h15 à 21h15
                            <br /><br />
                            <span>Accès bus :</span>
                            Ligne 11 Arrêt Terrasses
                            <br /><br />
                            Stationnement cour privative
                            <br />Accès personnes handicapées
                            <br /><br />
                            07 82 42 47 16
                            <br />lockquest.escape@gmail.com
                        </div>
                    </div>
                </div>
                <div>
                    <a class="facebook" href="https://www.facebook.com/lockquest.escape" target="_blank"></a>
                    <!--<a class="twitter" href="" target="_blank"></a>-->
                    <a class="instagram" href="https://www.instagram.com/lockquest.escape" target="_blank"></a>
                </div>
            </div>
        </div>

        <div id="leaves_sides">
            <div class="left"></div>
            <div class="right"></div>
        </div>

        <Video ref="videoPopin" />
        <Reservation ref="reservationPopin" />

        <Footer />
    </div>
</template>

<script>
import HeaderMenu_Site from '../../components/HeaderMenu_Site.vue';
import LateralMenu_Site from '../../components/LateralMenu_Site.vue';
import Footer from '../../components/Footer.vue';
import Video from '../../components/Video.vue';
import Reservation from '../../components/Reservation.vue';

import anime from 'animejs/lib/anime.es';
import { Carousel, Slide } from 'vue-carousel';

export default {
    name: "Site_HomePage",
    components: {
        HeaderMenu_Site,
        LateralMenu_Site,
        Footer,
        Carousel,
        Slide,
        Video,
        Reservation
    },
    data: () => ({
        ovOptions: {
            root: null,
            rootMargin: '0px 0px -50px 0px',
            treshold: 0
        }
    }),
    methods: {
        voirTrailer_buttonClick(video_url) {
            this.$refs.videoPopin.popin_videoDisplayed(video_url);
        },
        listeScores_buttonClick: function() {
            let routeData = this.$router.resolve({ name: 'site_resultatspage' });
            window.open(routeData.href, '_blank');
        },
        redirect(url, signet) {
            window.open(url, signet);
        },
        ovCallbackEntreprises(visible, entry) {
            if (!visible) {
                return;
            }

            anime({
                targets: entry.target,
                opacity: [0, 1],
                left: [0, '75%'],
                easing: 'easeOutElastic(1, 1)'
            });
        },
        ovCallbackPadquestPad(visible, entry) {
            if (!visible) {
                return;
            }

            anime({
                targets: entry.target,
                translateX: ['-2px', '2px'],
                duration: 50,
                direction: 'alternate',
                loop: 10,
                easing: 'easeOutBack'
            });
        },
        ovCallbackTarifs(visible, entry) {
            if (!visible) {
                return;
            }

            anime({
                targets: entry.target,
                opacity: [0, 1],
                translateX: [-50, 0],
                duration: 500,
                easing: 'linear'
            });
        },
        ovCallbackConcept(visible, entry) {
            if (!visible) {
                return;
            }

            anime({
                targets: entry.target,
                opacity: [0, 1],
                translateX: [50, 0],
                duration: 500,
                easing: 'linear'
            });
        },
        ovCallbackPadquest(visible, entry) {
            if (!visible) {
                return;
            }

            anime({
                targets: entry.target,
                opacity: [0, 1],
                translateX: [-50, 0],
                duration: 500,
                easing: 'linear'
            });
        },
        reserver_buttonClick: function(scenario_slug) {
            this.$refs.reservationPopin.popin_reservationDisplayed(scenario_slug);
        },
    }
}
</script>